'use client';

import React from 'react';
import NextLink from 'next/link';
import classNames from 'classnames';

// Types
import { CardProps, CardChildrenProps } from '../../types/display/card';

export const Card = ({
  to,
  rel,
  target,
  onClick,
  children,
  bgColour,
  className,
  component = 'div',
}: CardProps) => {
  if (to && onClick) {
    throw new Error(
      "Please do not use the 'to' property alongside the 'onClick' property.",
    );
  }

  const Component = component;

  return (
    <>
      {to && (
        <NextLink
          href={to}
          rel={rel}
          target={target}
          className={classNames('card', {
            [`${bgColour}`]: bgColour,
            [`${className}`]: className,
          })}
        >
          {children}
        </NextLink>
      )}

      {!to && (
        <Component
          onClick={(event) => onClick?.(event)}
          role={onClick ? 'button' : undefined}
          className={classNames('card', {
            [`${bgColour}`]: bgColour,
            [`${className}`]: className,
          })}
        >
          {children}
        </Component>
      )}
    </>
  );
};

export const CardHeader = ({
  addFlow,
  children,
  className,
  component = 'div',
}: CardChildrenProps) => {
  const Component = component;

  return (
    <Component
      className={classNames('card__header', {
        flow: addFlow,
        [`${className}`]: className,
      })}
    >
      {children}
    </Component>
  );
};

export const CardBody = ({
  addFlow,
  children,
  className,
  component = 'div',
}: CardChildrenProps) => {
  const Component = component;

  return (
    <Component
      className={classNames('card__content', {
        flow: addFlow,
        [`${className}`]: className,
      })}
    >
      {children}
    </Component>
  );
};

export const CardFooter = ({
  addFlow,
  children,
  className,
  component = 'div',
}: CardChildrenProps) => {
  const Component = component;

  return (
    <Component
      className={classNames('card__footer', {
        flow: addFlow,
        [`${className}`]: className,
      })}
    >
      {children}
    </Component>
  );
};
